<script lang="ts">
  import { assets } from "$app/paths";
  import Column from "$lib/components/Column/Column.svelte";
  import Grid from "$lib/components/Grid/Grid.svelte";
  import { links } from "$lib/data/footer.data";
  import FooterLinks from "./FooterLinks/FooterLinks.svelte";
  import cfg from "$lib/config/config";
  import Container from "$lib/components/Container/Container.svelte";
  import SubFooter from "./SubFooter/SubFooter.svelte";
  import NewsletterSignUp from "$lib/components/NewsletterSignUp/NewsletterSignUp.svelte";

  export let isPdpOrPlp: boolean;
</script>

<style lang="scss">
  .footer {
    &--wrapper {
      @include breakpoint(lg) {
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }
    background-color: $inverse-surface;
    padding: 48px 0 40px;
    @include breakpoint(md) {
      padding-bottom: 50px;
    }
    @include breakpoint(xl) {
      padding: 64px 0 69px;
    }
    &--signup {
      margin-bottom: 8px;
    }

    &--links {
      &__sm {
        width: 100%;
        grid-column-start: 1;
        grid-column-end: span 4;

        @include breakpoint(md) {
          grid-column-start: 5;
          grid-column-end: span 4;
        }
        @include breakpoint(lg) {
          display: none;
        }
      }
      &__lg {
        width: 100%;
        display: none;
        grid-column-end: span 2;
        @include breakpoint(lg) {
          display: block;
        }
      }
    }

    &--link-list {
      &__sm {
        border-top: 1px solid $inverse-on-surface-60;
        &--last {
          border-bottom: 1px solid $inverse-on-surface-60;
        }
      }
    }

    &--logo {
      margin-top: 8px;
      @include breakpoint(md) {
        margin-top: 10px;
      }
      @include breakpoint(xl) {
        margin-top: 34px;
      }
      img {
        width: 100%;
        aspect-ratio: 680/85 auto;
      }
    }
  }
</style>

<div
  class="footer--wrapper"
  aria-label="footer"
  role="contentinfo"
  data-cs-override-id="footer"
>
  <div class="footer">
    <Container>
      <Grid smCols={4} mdCols={8} lgCols={12}>
        <Column smSpan={4} mdSpan={4} lgSpan={4}>
          <div class="footer--signup">
            <NewsletterSignUp />
          </div>
        </Column>
        <div class="footer--links__sm">
          {#each links as link, i}
            <div
              class="footer--link-list__sm {i === links.length - 1
                ? 'footer--link-list__sm--last'
                : ''}"
            >
              <FooterLinks
                links={link.links}
                title={link.title}
                currentRegion={cfg.REGION_ID}
                mobile
              />
            </div>
          {/each}
        </div>
        {#each links as link}
          <div class="footer--links__lg">
            <FooterLinks
              links={link.links}
              title={link.title}
              currentRegion={cfg.REGION_ID}
            />
          </div>
        {/each}
        <Column smSpan={4} mdSpan={8} lgSpan={12}>
          <div class="footer--logo">
            <img src={`${assets}/wordmark-01.svg`} alt="Belstaff Logo" />
          </div>
        </Column>
      </Grid>
    </Container>
  </div>
  <SubFooter {isPdpOrPlp} />
</div>
